(function () {
	'use strict';

	angular
		.module('app.setup')
		.controller(
			'supplierWhitelist',
			supplierWhitelist
		);

	supplierWhitelist.$inject = [
		'$rootScope',
		'$scope',
		'$timeout'
	];

	function supplierWhitelist($rootScope, $scope, $timeout) {
		var vm = this;
	}
})();
